// extracted by mini-css-extract-plugin
export var menuIcon = "_qc-0";
export var menuIconInline = "_qc-1";